var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { apiCreateDocumentDownloadUrl } from '../../../actions/DocumentActions';
import { wrapDispatch } from '../../../helpers/action';
import { propId, propStr } from '../../../helpers/custom-prop-types';
import { openUrlNewTab } from '../../../helpers/files';
import DownloadIcon from '../../Icon/Svg/DownloadIcon';
import SubmitButton from '../../Ui/Button/SubmitButton';
const DocumentDownload = (props) => {
    const { code, id } = props;
    const unmountRef = useRef(false);
    useEffect(() => () => {
        unmountRef.current = true;
    }, []);
    const dispatch = useDispatch();
    const [loading, changeLoading] = useState(false);
    const onClickDownload = useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { value } = e.currentTarget;
            changeLoading(true);
            // api実行
            const res = yield wrapDispatch(dispatch, apiCreateDocumentDownloadUrl(value, code));
            const { payload: { name, url }, } = res;
            openUrlNewTab(url, name);
        }
        finally {
            if (!unmountRef.current) {
                changeLoading(false);
            }
        }
    }), [code, dispatch, changeLoading, unmountRef]);
    return (_jsx(SubmitButton, { buttonType: 'button', className: 'button center service has_left_icon', isDisabled: loading, isLoading: loading, onControlClick: onClickDownload, text: _jsxs(_Fragment, { children: [_jsx(DownloadIcon, { className: '' }), _jsx("span", { children: "\u8CC7\u6599\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9" })] }), value: id }));
};
DocumentDownload.propTypes = {
    code: propStr(),
    id: propId().isRequired,
};
DocumentDownload.defaultProps = {
    code: '',
};
export default DocumentDownload;
